import { Errors } from 'src/types';

const initialState = false;

const errorToastReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'error/show':
			return action.payload as keyof typeof Errors;
		case 'error/hide':
			return initialState;
		default:
			return state !== undefined ? state : null;
	}
};

export default errorToastReducer;
